import { render, staticRenderFns } from "./BranceCardImage.vue?vue&type=template&id=26271c05&"
import script from "./BranceCardImage.vue?vue&type=script&lang=js&"
export * from "./BranceCardImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports